import { render, staticRenderFns } from "./StatisticCardItems.vue?vue&type=template&id=d05c2514&"
import script from "./StatisticCardItems.vue?vue&type=script&lang=js&"
export * from "./StatisticCardItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports